<p-dialog [header]="header" [(visible)]="visible" [style]="{width: width}">
  <div class="text-center">{{message}}</div>
  <div class="flex justify-content-end mt-4">
     <p-button label="Yes" icon="pi pi-check" [outlined]="true" (click)="triggerAction()"></p-button>
  </div>
 </p-dialog>